<template>
  <LoadingButton
    v-if="label"
    @click.native="$emit('approve')"
    :loading="approving"
    class="btn btn-success mr-1 text-capitalize"
    :disabled="!disabled"
  >
    {{ label }}
  </LoadingButton>
</template>

<script>
import helpers from '@/Mixins/helpers';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  mixins: [helpers],

  components: {
    LoadingButton,
  },

  props: {
    block: Object,
    withCounterparty: Boolean,
    approving: Boolean,
  },

  computed: {
    pendingLabel() {
      if (this.userHasRole('approver')) {
        return 'approve';
      }
      return null;
    },

    originatorApproved() {
      if (this.withCounterparty) {
        if (this.userHasRole('approver')) {
          return 'accept';
        }
        return null;
      }
      return 'approved';
    },

    counterpartyApproved() {
      if (!this.withCounterparty) {
        if (this.userHasRole('approver')) {
          return 'accept';
        }
        return null;
      }
      return 'approved';
    },

    acceptededLabel() {
      return 'accepted';
    },

    label() {
      let label;

      // Incomplete
      if (this.block.state === 'incomplete' && this.block.value !== null) {
        label = this.pendingLabel;
      }

      // Pending
      if (this.block.state === 'pending') {
        label = this.pendingLabel;
      }

      // Originator Approved
      if (this.block.state === 'originatorApproved') {
        label = this.originatorApproved;
      }

      // Counterparty Approved
      if (this.block.state === 'counterpartyApproved') {
        label = this.counterpartyApproved;
      }

      // Accepted
      if (this.block.state === 'accepted') {
        label = this.acceptededLabel;
      }

      return label;
    },

    disabled() {
      if (!this.userHasRole('approver')) {
        return false;
      }

      if (this.label === 'approved' || this.label === 'accepted') {
        return false;
      }

      return true;
    },
  },
};
</script>
